/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Status_CompleteInputs */

const en_media_import_status_complete = /** @type {(inputs: Media_Import_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media import complete.`)
};

const fr_media_import_status_complete = /** @type {(inputs: Media_Import_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des medias terminee.`)
};

const de_media_import_status_complete = /** @type {(inputs: Media_Import_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienimport abgeschlossen.`)
};

const it_media_import_status_complete = /** @type {(inputs: Media_Import_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione multimediale completata.`)
};

const ru_media_import_status_complete = /** @type {(inputs: Media_Import_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт медиафайлов завершен.`)
};

const es_media_import_status_complete = /** @type {(inputs: Media_Import_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de medios completada.`)
};

const zh_cn2_media_import_status_complete = /** @type {(inputs: Media_Import_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体导入完成。`)
};

const ja_media_import_status_complete = /** @type {(inputs: Media_Import_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのインポートが完了しました。`)
};

const hi_media_import_status_complete = /** @type {(inputs: Media_Import_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया आयात पूर्ण हो गया।`)
};

const pt_pt2_media_import_status_complete = /** @type {(inputs: Media_Import_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de mídia concluída.`)
};

/**
* | output |
* | --- |
* | "Media import complete." |
*
* @param {Media_Import_Status_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_status_complete = /** @type {((inputs?: Media_Import_Status_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Status_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_status_complete(inputs)
	if (locale === "de") return de_media_import_status_complete(inputs)
	if (locale === "it") return it_media_import_status_complete(inputs)
	if (locale === "ru") return ru_media_import_status_complete(inputs)
	if (locale === "es") return es_media_import_status_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_status_complete(inputs)
	if (locale === "ja") return ja_media_import_status_complete(inputs)
	if (locale === "hi") return hi_media_import_status_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_status_complete(inputs)
	return en_media_import_status_complete(inputs)
});